export const NON_EMPTY_CARTS_MERGED_SESSION_STORAGE = "nonEmptyCartsMerged";
